module.exports = __webpack_public_path__ + "image_not_found.png?e2085500a0551e19eab80e765a2ed792";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image_not_found.png
// module id = 525
// module chunks = 2